(function() {
    'use strict';

    let isPrerender = /prerender/i.test(navigator.userAgent);
    if (!isPrerender) {
        return;
    }

    let core = angular.module('core');

    let apiCallLog = [];

    //This is to record what api requests are made, so to track down what is going wrong with the prerender.
    core.decorator('$http', function($delegate) {
        let $http = $delegate;
        let oldGet = $http.get;
        $http.get = (...args) => {
            let log = {
                url: args[0],
                time: new Date()
            };
            apiCallLog.push(log);
            return oldGet.apply($http, args)
                .then(response => {
                    log.status = `${response.status} ${response.statusText}`;
                    return response;
                })
                .catch(error => {
                    log.error = `${error.status} ${error.statusText}`;
                    throw error;
                })
                .finally(() => {
                    log.time = new Date() - log.time;
                });
        };
        return $delegate;
    });

    core.directive('prerenderLogging', () => ({
        restrict: 'E',
        template: '{{apiCallLog|json:false}}',
        link: scope => scope.apiCallLog = apiCallLog
    }));

    if (console) {
        let oldError = console.error;
        console.error = (...args) => {
            apiCallLog.push({
                jsError: args
            });
            oldError && oldError.apply(console, args);
        };
    }
})();
